<template>
    <div>
        <template v-if="hasPermission">
            <vx-card noShadow noRound>
                
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <label class="vs-input--label block">In/Out</label>
                        <div class="flex mt-3 align-center">
                            <vs-radio v-model="direction" vs-name="direction" vs-value="in" :disabled="!editPermission">Stock IN</vs-radio>
                            <vs-radio v-model="direction" vs-name="direction" vs-value="out" :disabled="!editPermission" class="mx-3">Stock OUT</vs-radio>
                        </div>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <SelectForeign
                            :model.sync="stock_log.stock"
                            label="Select Stock"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.stock_list}?active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                            :disabled="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.stock">
                            {{ api_errors.stock.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <label class="vs-input--label block mb-1">Quantity</label>
                        <vs-input
                            :value="Math.abs(stock_log.change)"
                            @input="(val) => update_value(val)"
                            class="w-full"
                            type="Number"
                            step="0.001"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.change">
                            {{ api_errors.change.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <label class="vs-input--label block mb-1">Description</label>
                        <vs-textarea v-model="stock_log.description" :disabled="!editPermission" />
                        <small class="block text-danger mt-1" v-if="api_errors.description">
                            {{ api_errors.description.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                
                <vs-row class="mt-base" v-if="editPermission">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";

export default {
    data() {
        return {
            stock_log_id: this.$route.params.stock_log_id,
            
            direction: 'in',

            stock_log: {
                id: null,
                stock: null,
                change: null,
                description: null
            },

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.stock_log_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        },
        "direction"(newV, oldV) {
            if (newV==oldV) return
            this.update_value(this.stock_log.change)
        }
    },
    computed: {
        viewStockLog() {
            return this.hasAccess('read', 'stock_log', 'all')
        },
        createStockLog() { 
            return this.hasAccess('create', 'stock_log', 'all') 
        },
        editStockLog() { 
            return this.hasAccess('edit', 'stock_log', 'all') 
        },
        hasPermission() {
            return (!this.stock_log.id && this.createStockLog) || (this.stock_log.id && this.editStockLog) || (this.stock_log.id && this.viewStockLog)
        },
        editPermission() {
            return (!this.stock_log.id && this.createStockLog) || (this.stock_log.id && this.editStockLog)
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.stock_log_id = this.$route.params.stock_log_id

            if (this.stock_log_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.stock_log_get + this.stock_log_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.stock_log = res
                    this.direction = this.stock_log.change > 0 ? 'in' : 'out'
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.stock_log_get
            if (this.stock_log_id) {
                request_method = 'PUT'
                url += this.stock_log_id + '/'
            }

            let payload = this.stock_log

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.submit_disabled = false
                    this.stock_log = res
                    this.direction = this.stock_log.change > 0 ? 'in' : 'out'
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'stock-log-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        },
        update_value(val) {
            val = Math.abs(Number(val) || 0)
            if (this.direction == 'in') {
                this.stock_log.change = val
            } else {
                this.stock_log.change = -1 * Number(val)
            }
        }
    }
}
</script>